import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';

import { Props, Link as LinkLegacy } from 'ha/ui.legacy/Link';

type LinkProps = Omit<Props, 'skipLangFormat'>;
type ActualRouterLinkProps = RouterLinkProps & {
  innerRef: React.Ref<HTMLAnchorElement>;
};

const ReactRouterLink = React.forwardRef<
  HTMLAnchorElement,
  ActualRouterLinkProps
>((props, ref) => {
  return (
    <RouterLink {...props} ref={ref}>
      {props.children}
    </RouterLink>
  );
});

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <LinkLegacy ref={ref} {...props} component={ReactRouterLink} skipLangFormat>
    {props.children}
  </LinkLegacy>
));
export { Link };
